var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              configuracaoFiltro: _vm.configuracaoFiltro,
              filtroRapido: _vm.filtroRapido
            },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.clear }
          })
        ],
        1
      ),
      _c("app-listagem", {
        attrs: {
          "has-refresh-button": true,
          showButtonOrdemServico: _vm.showButtonOrdemServico,
          showButtonAssinatura: false,
          "has-expansivel": false,
          "json-headers": _vm.colunas,
          "json-data": _vm.items,
          totalElements: _vm.totalElements,
          pagina: _vm.filtro.pagina,
          hasFiltroRapido: true,
          filtro: _vm.filtro,
          infoPrazos: _vm.showInfoVencimento() && _vm.infoPrazos
        },
        on: {
          atualizarFiltro: _vm.atualizarFiltro,
          updateListagem: _vm.refresh,
          changePage: _vm.changePage,
          sort: _vm.sort,
          executar: _vm.executar,
          selected: _vm.CRIAR_ORDEM_SERVICO,
          selectItem: _vm.SELECIONA_PROCESSO
        }
      }),
      _vm.showButtonOrdemServico
        ? _c("span", { staticClass: "padding-left" }, [
            _vm._v(_vm._s("Processos Selecionados: " + _vm.idsProcessos.length))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a1a482a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a1a482a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/listagem/CaixaAguardandoRespostaIndeferimento.vue
// module id = null
// module chunks = 